import * as React from "react"

import { cn } from "@/lib/utils"
import { useTypingAssist } from "@/lib/use-typing-assist"

type TextareaProps = React.ComponentProps<"textarea"> & {
  /** Corretor, maiúscula no começo da frase e acentos óbvios. Padrão: ligado. */
  typingAssist?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, typingAssist = true, ...props }, ref) => {
    const assist = useTypingAssist(typingAssist, ref)
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...assist}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
